"use client";

import { useCampaignTagsForProduct } from "@/features/campaigns/hooks";
import { useGlobal } from "@/features/global/GlobalContext";
import type { ProductCard } from "@/lib/centra";
import styles from "./ProductDetailsPage.module.css";

interface ProductDetailsPriceProps {
	price: string;
	isDiscounted?: boolean;
	priceBeforeDiscount?: string;
	product: {
		displayItemId: string;
		sku?: string;
		centraProductNumber?: string;
	};
}

export const ProductDetailsPrice = ({
	price,
	isDiscounted,
	priceBeforeDiscount,
	product,
}: ProductDetailsPriceProps) => {
	const campaignTags = useCampaignTagsForProduct(product as ProductCard);
	const { data: globalData } = useGlobal();

	const campaignTagColor = campaignTags.find((tag) => tag.color)?.color;
	const colorEntry = campaignTagColor ? globalData.colorMap[campaignTagColor] : undefined;

	return (
		<>
			{colorEntry && isDiscounted ? (
				<span
					className={styles.campaignPrice}
					style={
						{
							"--tag-color": colorEntry.color,
							"--tag-foreground": colorEntry.foreground,
						} as React.CSSProperties
					}
				>
					{price}
				</span>
			) : (
				price
			)}
			{isDiscounted && (
				<span className={styles.discounted}>
					<s>{priceBeforeDiscount}</s>
				</span>
			)}
		</>
	);
};
